import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custombase',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custombase.component.html',
  styleUrls: ['./custombase.component.scss']
})
export class CustombaseComponent {
  roleRightObj: any;
  constructor() {
    let roleRightsJson = JSON.parse(localStorage.getItem('sideMenuList'));
    // console.log(roleRightsJson, "ppppppppppppppp")
    this.roleRightObj = {};
    if (roleRightsJson && roleRightsJson.length !== 0) {
      for (let i = 0; i < roleRightsJson.length; i++) {
        const blockname = roleRightsJson[i].block_name;
        const right = {};
    
        for (let j = 0; j < roleRightsJson[i].data.length; j++) {
          const pagename = roleRightsJson[i].data[j].page_name;
          const writeValue = roleRightsJson[i].data[j].write;
    
          // Check for actions in the page and include them
          const actions = roleRightsJson[i].data[j].actions || [];
          const actionsObj = {};
    
          // Map actions as key-value pairs
          for (const action of actions) {
            actionsObj[action.page_name] = {
              read: action.read,
              title: action.title,
            };
          }
    
          // Create an object for the page
          right[pagename] = {
            write: writeValue,
            actions: actionsObj,
          };
        }
    
        // Assign the block object
        this.roleRightObj[blockname] = right;
      }
    }
  
  }

  home() {
    return this.roleRightObj?.Home?.['home'].write;
  }
  topology() {
    return this.roleRightObj?.Topology?.['topology']?.write;
  }
  assetsRight() {
    return this.roleRightObj?.Visibility?.['assets']?.write;

  }
  devicesViewRight() {
    return this.roleRightObj?.Visibility?.['devices-view']?.write;
  }
  assetsDebugRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.debug.read;

  }
  assetssetWifiRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.setWifi.read;
  }

  transitionDownloadRight() {
    return this.roleRightObj?.Visibility?.['transition-report']?.actions?.download.read;
  }
  assetsrebootRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.reboot?.read;

  }
  assetsresetAPNRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.resetAPN?.read;

  }
  assetsdeleteRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.delete?.read;

  }
  assetsaddDeviceRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.addDevice?.read;

  }


  walkTestReport() {
    return this.roleRightObj?.Visibility?.['walk_test_report']?.write;

  }
  walkTestSummary() {
    return this.roleRightObj?.Visibility?.['walk_test_summary']?.write;

  }
  walkTestDetailedReport() {
    return this.roleRightObj?.Visibility?.['walk_test_detailed_report']?.write;

  }
  cellAnalysisReport() {
    return this.roleRightObj?.Visibility?.['physcial_cell_analysis_report']?.write;

  }
  statistics() {
    return this.roleRightObj?.Visibility?.['statistics']?.write;

  }
  signalHeatMap() {
    return this.roleRightObj?.Visibility?.['signal_heat_map']?.write;

  }
  dashBoard() {
    return this.roleRightObj?.Visibility?.['dashboard']?.write;

  }
  telemetry() {
    return this.roleRightObj?.Visibility?.['telemetry']?.write;

  }
  devicesList() {
    return this.roleRightObj?.Visibility?.['devices']?.write;

  }
  sensors() {
    return this.roleRightObj?.Visibility?.['edge-rules-engine']?.write;

  }
  edgeRulesEngine() {
    return this.roleRightObj?.Visibility?.['edge-locate']?.write;

  }
  edgeLocate() {
    return this.roleRightObj?.Visibility?.['edge-locate-visualization']?.write;
  }
  coverageReport() {
    return this.roleRightObj?.Visibility?.['coverage-report']?.write;
  }
  GeoFencingControl() {
    return this.roleRightObj?.Visibility?.['edge-geo-fencing-control']?.write;
  }
  edgeIntelligence() {
    return this.roleRightObj?.Intelligence?.['edge-intelligence']?.write;

  }
  mlModels() {
    return this.roleRightObj?.Intelligence?.['ml-models']?.write;

  }
  modelTraining() {
    return this.roleRightObj?.Intelligence?.['model-training']?.write;

  }
  topologyManager() {
    return this.roleRightObj?.Intelligence?.['topology-manager']?.write;

  }
  dataModel() {
    return this.roleRightObj?.Intelligence?.['data-model']?.write;

  }
  dataModeling() {
    return this.roleRightObj?.Intelligence?.['data-modeling']?.write;

  }
  edgeCommandControl() {
    return this.roleRightObj?.Actionability?.['edge-command-control']?.write;

  }
  edgeRulesEngineActionabilty() {
    return this.roleRightObj?.Actionability?.['edge-rules-engine']?.write;

  }
  geoFence() {
    return this.roleRightObj?.Actionability?.['geo-fence']?.write;

  }
  liveWalkTest() {
    return this.roleRightObj?.Actionability?.['live-walk-test']?.write;

  }
  walktestSchduler() {
    return this.roleRightObj?.Actionability?.['walk-test-scheduler']?.write;

  }
  apiGatewayControl() {
    return this.roleRightObj?.Administration?.['api-gateway-control']?.write;
  }
  edgeManagement() {
    return this.roleRightObj?.Administration?.['edge-management']?.write;
  }
  admin() {
    return this.roleRightObj?.Administration?.['admin']?.write;
  }
  cloudManagement() {
    return this.roleRightObj?.Administration?.['cloud-management']?.write;
  }
  mnoMapping() {
    return this.roleRightObj?.Administration?.['mno-mapping']?.write;
  }
  usersManager() {
    return this.roleRightObj?.Administration?.['users-manager']?.write;
  }
  floorMapsManager() {
    return this.roleRightObj?.Administration?.['floor-maps-manager']?.write;
  }
  deviceUpgradeManager() {
    return this.roleRightObj?.Administration?.['device-upgrade-manager']?.write;
  }
  diagnosticTests() {
    return this.roleRightObj?.Administration?.['diagnostic-tests']?.write;
  }
  containerDiagnostics() {
    return this.roleRightObj?.Administration?.['diagnostic-tests']?.actions?.container_diagnostics?.read;
  }
  productionTest() {
    return this.roleRightObj?.Administration?.['diagnostic-tests']?.actions?.production_test?.read;
  } 
  xedgeDeviceDiagnostics() {
    return this.roleRightObj?.Administration?.['diagnostic-tests']?.actions?.xedge_device_diagnostics?.read;
  } 
  deviceHealthStatus() {
    return this.roleRightObj?.Administration?.['diagnostic-tests']?.actions?.device_health_status?.read;
  } 
  autoRecoveryJobs() {
    return this.roleRightObj?.Administration?.['diagnostic-tests']?.actions?.auto_recovery_jobs?.read;
  }
  rolesManager() {
    return this.roleRightObj?.Administration?.['roles-manager']?.write;
  }
  deviceConfiguration() {
    return this.roleRightObj?.Administration?.['device-configuration']?.write;
  }
  groupsManager(): boolean {
    return this.roleRightObj?.Administration?.['groups-manager']?.write;
  }
  globalConfiguration(): boolean { 
    return this.roleRightObj?.Administration?.['global-configuration']?.write;
   } // global configuration
   globalConfigurationIperfServers(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.iperf_servers?.read;
   }
   globalConfigurationFtpServers(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.ftp_servers?.read;
   }
   globalConfigurationUpgradeServers(): boolean { 
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.upgrade_servers?.read;
   }
   globalConfigurationDeviceDiagnostics(): boolean { 
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.device_diagnostics?.read;
   }
   globalConfigurationDiagnosticJobs(): boolean { 
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.diagnostic_jobs?.read;
   }
   globalConfigurationSecretKey(): boolean { 
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.secret_key?.read;
   }
   globalConfigurationRuleEngine(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.rule_engine?.read;
   }
   globalConfigurationFAQS(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.faqs?.read;
   }
   globalConfigurationDeploymentName(): boolean {
    // return this.roleRightObj?.Administration?.['global-configuration']?.actions?.deployment_name?.read;
    return true;
   }

   globalConfigurationOutdoorMapType(): boolean {
    return true;
   }

   globalConfigurationSpeedTestServers(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.speed_test_servers?.read;
   }

   testsRoleCheck(key:any){
      let k = this.roleRightObj?.Actionability?.['live-walk-test']?.actions?.[key]?.hasOwnProperty("read");
    return !k?true:this.roleRightObj?.Actionability?.['live-walk-test']?.actions?.[key]?.read;
   }

   globalConfigurationKPIConfigS(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.kpi_config?.read;
   }
   globalConfigurationSecurityProfile(): boolean {
    return this.roleRightObj?.Administration?.['global-configuration']?.actions?.security_profiles?.read;
   }
   deviceConfigTelemetry(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.telemetry?.read;
   }
   deviceConfigAdminStatus(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.admin_status?.read;
   }
   deviceConfigIdentifyDevice(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.identify_device?.read;
   }
   deviceConfigRAT(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.rat_priority?.read;
   }
   deviceConfigRadioControl(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.radio_control?.read;
   }
   deviceConfigAirplaneMode(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.airplane_mode?.read;
   }
   deviceConfigMBNProfile(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.mbn_profiles?.read;
   }
   deviceConfigRestoreBands(): boolean {
    return this.roleRightObj?.Administration?.['device-configuration']?.actions?.restore_bands?.read;
   }
   assetsAdvConfigRight() {
    return this.roleRightObj?.Visibility?.['assets']?.actions?.advConfig?.read;
   }
}
